<template>
  <div>
    <!--    <page-header></page-header>-->

    <router-view class="pb-14"></router-view>
  </div>
</template>
<script>
//import PageHeader from '@/components/common/PageHeader.vue';

export default {
  components: {
    //  PageHeader,
  },
};
</script>
